import React, { useEffect, useState, useContext } from "react";
import "./layout.scss";
import { styled } from "@mui/material/styles";
import { useQuery } from "@apollo/client"
import {
  Box,
  Drawer,
  AppBar,
} from "@mui/material";
//icons
import { Outlet } from "react-router-dom";
import MenuNavbar from "../Menu/MenuNavbar";
import TopNavbar from "../Menu/TopNavbar";
import TopNavbarMobile from "../Menu/TopNavbarMobile";
import { GET_USER_LOGIN } from "../Schema/Users";
import { AuthContext } from "../Context/AuthContext";
// import logo from "../Assets/logoLogin.svg";
import { useNavigate } from "react-router-dom";

const drawerWidth = 270;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

export default function Layout() {

  const navigate = useNavigate()

  //====================== Hook Open Menu Mobile ======================
  const [openMobile, setOpenMobile] = React.useState(false);
  const handleDrawerOpenMobile = () => setOpenMobile(true);
  const handleDrawerCloseMobile = () => setOpenMobile(false);

  const handleClickOutside = (event) => {
    if (openMobile && event.target instanceof HTMLElement) {
      // Check if the click is outside the drawer
      if (!event.target.closest(".MuiDrawer-paper")) {
        handleDrawerCloseMobile();
      }
    }
  };

  const { dispatch, setAlert } = useContext(AuthContext);

  const { refetch } = useQuery(GET_USER_LOGIN, {
    fetchPolicy: "network-only",
    onError: ({ message }) => {
      // console.log("error::", message);
      if (message === "Not Authorized" || message === "Session expired") {
        // console.log("remove ........")
        setAlert(true, "error", { message_kh: "អ្នកត្រូវបានចាកចេញ!", message_en: "You are loggin out!" });
        window.localStorage.removeItem("token");
        dispatch({
          type: "LOGGED_IN_USER",
          payload: null,
        });
        window.location.reload(false);
        navigate("/login");
      }
    },
  });

  useEffect(() => {
    const interval = setInterval(() => {
      refetch().then(({ data }) => {
        // console.log("Refetched data:", data);
        if (!data?.getUserLogin?.is_success) {
          setAlert(true, "error", data?.getUserLogin?.message);
          // setAlert(true, "error", { message_kh: data?.getUserLogin?.message?.message_kh, message_en: data?.getUserLogin?.message?.message_en });
          window.localStorage.removeItem("token");
          dispatch({
            type: "LOGGED_IN_USER",
            payload: null,
          });
          window.location.reload(false);
          navigate("/login");
        } else {
          window.localStorage.setItem("logIn", JSON.stringify(data?.getUserLogin?.data));
        }
      });
    }, 30000);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [refetch]);

  // =========================== Resize width ==========================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);
  // =========================== End Resize width ==========================

  return (
    <Box className="main">
      {width > 1000 ? (
        <Box className="inner" sx={{ display: "flex" }}>
          <AppBar
            sx={{ boxShadow: "none", backgroundColor: "red", height: "30px" }}
            position="fixed"
            open={true}
          >
            <TopNavbar />
          </AppBar>
          <Main open={true} sx={{ marginTop: "60px" }} className="outlet-container">
            <Outlet />
          </Main>
        </Box>
      ) : (
        <Box className="inner" sx={{ display: "flex" }} onClick={handleClickOutside}>
          <AppBar sx={{ boxShadow: "none" }} position="fixed" open={true}>
            <TopNavbarMobile handleDrawerOpen={handleDrawerOpenMobile} />
          </AppBar>
          <Drawer
            sx={{
              width: drawerWidth,
              flexShrink: 0,
              "& .MuiDrawer-paper": {
                width: drawerWidth,
                boxSizing: "border-box",
              },
            }}
            variant="persistent"
            anchor="left"
            open={openMobile}
          >
            <MenuNavbar open={openMobile} handleDrawerClose={handleDrawerCloseMobile} />
          </Drawer>

          <Main open={openMobile} sx={{ marginTop: "60px" }} className="outlet-container">
            <Outlet />
          </Main>
        </Box>
      )}
    </Box>
  );
}
